import Vue from "vue";
import Vuex from "vuex";

import gestionTiempos from "./gestionTiempos/gestionTiempos";
import assignCards from "./gestionTiempos/assignCards";
import changeGroup from "./gestionTiempos/changeGroup";
import changeSchedule from "./gestionTiempos/changeSchedule";
import changeSettlementModel from "./gestionTiempos/changeSettlementModel";
import employees from "./gestionEmpleados/employees";
import assignWatches from "./gestionEmpleados/assignWatches";
import accountBalances from "./gestionEmpleados/accountBalances";
import atributes from "./gestionEmpleados/atributes";
import tags from "./etiquetas/tags";
import permissions from "./gestionEmpleados/permissions";
import loader from "./loader";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    loader,
    gestionTiempos,
    employees,
    accountBalances,
    atributes,
    assignCards,
    changeGroup,
    changeSchedule,
    changeSettlementModel,
    assignWatches,
    tags,
    permissions,
  },
});
